/**
 * localStorage keys for persisted production-planning UI preferences.
 *
 * String values MUST stay in sync with the legacy hcem `PlannerLSSettingsKeys`
 * enum (packages/hcem/src/shared/enums.ts) so that user preferences persisted
 * while using the legacy app carry over when the feature runs inside Suite.
 */
export const ProductionPlanningLSSettingsKeys = {
  PlanningSliderSettings: 'planning_slider_settings',
  PlanningSiloSectionSettings: 'planning_silo_section_settings',
  PlanningElectricityChartSettings: 'planning_electricity_chart_settings',
  PlanningCommentsSidebarSettings: 'planning_comments_sidebar_settings',
  PlanningChartCardSettings: 'planning_chart_card_settings',
  PlanningKPITableSettings: 'planning_kpi_table_settings'
} as const

export type ProductionPlanningLSSettingsKey =
  (typeof ProductionPlanningLSSettingsKeys)[keyof typeof ProductionPlanningLSSettingsKeys]
